import React from 'react';
import './MScInAccountingAndFinance.css'; // Optional: Create a CSS file for styling

const BAInAgriculturalEconomics = () => {
  return (
    <div className="msc-container" style={{ padding: '20px', maxWidth: '800px',marginTop: '160px',marginLeft:'70px'}}>
      <h1 style={{ textAlign: 'center' }}>
        📘 Bachelor of Arts in Agricultural Economics
      </h1>

      <section>
        <h2 style={{ textAlign: 'center' }}>Program Overview</h2>
        <p>
          The BA in Agricultural Economics at Admas University prepares students to apply economic principles to the agricultural sector. This program focuses on enhancing food security, improving rural livelihoods, and promoting sustainable agricultural development through evidence-based policy and decision-making.
        </p>
      </section>

      <section>
        <h2>🎓 Program Objectives</h2>
        <ul>
          <li>To provide a comprehensive understanding of the economics of agriculture and rural development.</li>
          <li>To build skills in agricultural policy analysis, farm management, and agribusiness.</li>
          <li>To produce graduates capable of solving real-world agricultural and environmental challenges.</li>
          <li>To promote innovation and entrepreneurship in agricultural sectors.</li>
        </ul>
      </section>

      <section>
        <h2>📚 Key Courses</h2>
        <ul>
          <li>Principles of Agricultural Economics</li>
          <li>Farm Management</li>
          <li>Natural Resource Economics</li>
          <li>Agribusiness Management</li>
          <li>Rural Development</li>
          <li>Quantitative Methods in Economics</li>
          <li>Development Economics</li>
          <li>Project Planning and Evaluation</li>
          <li>Food Policy and Trade</li>
          <li>Senior Research Project</li>
        </ul>
      </section>

      <section>
        <h2>🎓 Admission Requirements</h2>
        <ul>
          <li>Completion of secondary education with a passing grade on the Ethiopian university entrance exam.</li>
          <li>TVET diploma holders in related areas may qualify through a bridging or advanced standing program.</li>
        </ul>
      </section>

      <section>
        <h2>🧭 Career Opportunities</h2>
        <p>
          Graduates can pursue roles in agricultural planning, policy analysis, rural development programs, research institutions, NGOs, agribusiness firms, and government agencies focused on food security and environmental sustainability.
        </p>
      </section>

      <section>
        <h2>🏛️ Why Choose Admas University?</h2>
        <ul>
          <li>Curriculum aligned with national priorities and rural development goals.</li>
          <li>Experienced faculty with expertise in agricultural economics and development.</li>
          <li>Hands-on learning through case studies, fieldwork, and research projects.</li>
          <li>Campuses and distance learning options available throughout Ethiopia.</li>
        </ul>
      </section>
    </div>
  );
};

export default BAInAgriculturalEconomics;